<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">业务合同</span>
      </div>
    </div>
    <div class="project_contract_div">

      <div class="button_div">
        <div class="hint_txt">
          使用提示：项目合同到期或未上传的情况，请点击按钮进行上传PDF。
        </div>
        <Button type="primary" size="small" style="font-size: 13px" @click="add_contract_show = true">
          <Icon type="md-add" />添加业务合同
        </Button>
      </div>
      <div>
        <Table size="small" :columns="project_contract_columns" :data="contract_list">
          <template #download_contract="{ row }">
            <span class="download_span" @click="view_contract(row)">
              <Icon type="ios-cloud-download-outline" />点击查看
            </span>
          </template>

        </Table>
      </div>
    </div>

    <Drawer title="业务合同" :closable="true" v-model="show" width="400px">
      <div class="button_div">
        <Button type="primary" size="small" style="font-size: 13px" @click="add_contract_show = true">
          <Icon type="ios-add-circle-outline" />添加业务合同
        </Button>
      </div>
      <div class="card_list">
        <Spin fix v-if="loading"></Spin>
        <div v-for="(item, i) in contract_list" :key="i" class="contract_card">
          <img src="@/assets/image/detail/pdf.png" class="pdf_icon" alt="" />
          <span v-if="item.is_expire" class="iconfont iconyiguoqi1"></span>
          <div class="card_span">
            合同名称：<span class="card_span">{{ item.name }}</span>
          </div>
          <div class="card_span">
            合同时间：<span class="card_span">{{ item.start_time }} 至 {{ item.end_time }}</span>
          </div>
          <div>上传时间：{{ item.create_time }}</div>
          <div>上传用户：{{ item.create_user_name }}</div>
          <div>
            审核状态：
            <Tag color="warning" style="color: #fff" v-if="item.audit_status == 0">待审核</Tag>
            <Tag color="success" style="color: #fff" v-if="item.audit_status == 1">审核通过</Tag>
            <Tag color="error" style="color: #fff" v-if="item.audit_status == 2">审核不通过</Tag>
          </div>
          <div class="">合同编号：{{ item.contract_short_id }}</div>

          <div>
            更多操作：<span @click="view_contract(item)" class="view_contract">
              <Icon type="md-eye" />查看合同
            </span>
            <span class="del" @click="click_del_contract(item)">
              <Icon type="md-close" />删除
            </span>
          </div>
        </div>
      </div>
    </Drawer>
    <Modal v-model="add_contract_show" title="添加合同" :footer-hide="true">
      <div>
        <Alert type="warning" style="font-size: 13px">请上传高清扫描并且有章的PDF版合同，存档使用，不要上传模糊看不清字的PDF跟空白合同PDF! PDF文件如过大请先压缩，<a target='_blank' href="/tools/compress/pdf">点击去压缩PDF</a></Alert>
      </div>
      <div>
        <div class="add_contract_field" style="margin-bottom: 10px">
          <div class="add_title">合同名称：</div>
          <div>
            <Input v-model="contract_name" placeholder="请输入合同名称..." style="width: 300px" />
          </div>
        </div>
        <div class="add_contract_field">
          <div class="add_title">合同PDF：</div>
          <div>
            <Upload :action="upload_url" :on-success="upload_success" ref="upload">
              <Button icon="ios-cloud-upload-outline">点击上传文件</Button>
            </Upload>
          </div>
        </div>
        <div class="add_contract_field">
          <div class="add_title">合同起止时间:</div>
          <div class="add_contract_date">
            <DatePicker v-model="start_time" type="date" placeholder="Select date"
              style="width: 120px; margin-right: 5px" />
            <span style="padding-top: 5px">-</span>

            <DatePicker :disabled="is_long_time" v-model="end_time" type="date" placeholder="Select date"
              style="width: 120px; margin-left: 5px" />
            <div class="is_long_time">
              <Checkbox style="margin-left: 10px" v-model="is_long_time">是否长期</Checkbox>
            </div>
          </div>
        </div>
        <div class="add_contract_button_div">
          <Button @click="click_add_contract_affirm(row)" style="font-size: 12px" type="primary">
            <Icon type="md-add" />确认添加
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page,get_view_file_url } from "@/utils/http.js";

export default {
  name: "business_contract",
  data() {
    return {
      show: false,
      project_id: "",
      add_contract_show: false,
      start_time: new Date(),
      end_time: new Date(),
      upload_contract_url: "",
      upload_url:
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/business_contract/upload_contract?token=" +
        this.$cookies.get("dx_token"),

      contract_list: [],
      contract_name: "",
      loading: false,
      is_long_time: false,
      // 借支
      jiezhi_hexiao_show: false,
      project_contract_columns: [
        {
          title: '合同编号',
          key: 'contract_short_id',
          width: 120
        },
        {
          title: '合同名称',
          key: 'name',
          width: 200
        },
        {
          title: '合同开始时间',
          key: 'start_time',
          width: 120
        },
        {
          title: '合同结束时间',
          key: 'end_time',
          width: 120
        },
        {
          title: '查看/下载合同',
          key: 'create_time',
          slot: 'download_contract',
          width: 120
        },
        {
          title: '上传用户',
          key: 'create_user_name',
          width: 120
        },
        {
          title: '上传时间',
          key: 'create_time',
          minWidth: 140
        },

      ],
    };
  },

  methods: {

    click_del_contract(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除业务合同[" + item.contract_short_id + "]，是否继续？</p>",
        onOk: () => {
          that.del_contract_request(item);
        },
        onCancel: () => { },
      });
    },

    del_contract_request(item) {
      var that = this;
      var body = {
        contract_id: item.contract_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/business_contract/del_project_contract",
        body,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });

            that.get_project_contract_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    upload_success(e) {
      console.log(e);
      if (e.code != 0) {
        this.$Message.error(e.msg);
        this.$refs.upload.clearFiles();
        this.upload_contract_url = "";
      } else {
        this.$Message.success(e.msg);
        this.upload_contract_url = e.data.object_name;
      }
    },
    open(project_id, status) {

      if (status == 1) {
        this.show = true;
      }
      this.project_id = project_id;
      this.get_project_contract_data();
    },

    //获取业务合同列表
    get_project_contract_data() {
      var that = this;
      console.log("获取业务合同");
      var body = {
        project_id: this.project_id,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/business_contract/contract_list",
        body,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.contract_list = res.data.data_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_add_contract_affirm() {
      if (this.upload_contract_url == "") {
        this.$Message.error("请上传合同PDF");
        return;
      }
      var start_time_tsp = this.start_time.getTime() / 1000;
      var end_time_tsp = this.end_time.getTime() / 1000;

      if (end_time_tsp <= start_time_tsp && this.is_long_time == false) {
        this.$Message.error("合同时间到期时间异常");
        return;
      }
      var body = {
        start_time: Number(start_time_tsp),
        end_time: Number(end_time_tsp),
        url: this.upload_contract_url,
        project_id: this.project_id,
        name: this.contract_name,
        is_long_time: this.is_long_time,
      };
      this.add_contract_request(body);

      console.log(body);
    },

    view_contract(item) {
      open_new_page(item.contract_url);
    },

    add_contract_request(body) {
      var that = this;

      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/business_contract/add_project_contract",
        body,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_contract_show = false;
            that.get_project_contract_data();
            that.contract_detail_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.download_span {
  color: #0466dd;
  cursor: pointer;
}

.project_contract_div {
  margin-top: 10px;
  margin-bottom: 15px;
  padding: 0 10px
}

.title_text2 {
  font-weight: 600;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.del {
  color: rgb(210, 58, 58);
  cursor: pointer;
  margin-left: 10px;
}

.pdf_icon {
  width: 70px;
  height: 70px;
  opacity: 0.2;
  position: absolute;
  right: 10px;
  top: 20px;
}

.is_long_time {
  display: flex;
  align-items: flex-end;
}

.add_contract_date {
  display: flex;
}

.iconyiguoqi1 {
  color: red;
  font-size: 50px;
  position: absolute;
  right: 20px;
}

.view_contract {
  color: #0466dd;
  cursor: pointer;
}

.card_list {
  height: calc(100vh - 130px);
  overflow: auto;
  padding: 10px 0;
}

.card_span {
  color: #4b4b4b;
  font-weight: 600;
}

.contract_card {
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  box-shadow: 0 0 3px #f7f7f7;
  color: #a8a8a8;
  padding: 10px;
  font-size: 13px;
  margin-bottom: 10px;
  position: relative;
}

.add_contract_button_div {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.add_title {
  width: 100px;
  flex-shrink: 0;
}

.add_contract_field {
  display: flex;
  align-items: center;
}

.hint_txt {
  padding-left: 10px;
  color: #939393;
  font-size: 13px;
  ;
}


.button_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* position: absolute; */
  bottom: 10px;
  margin-bottom: 5px;
  /* background: red; */
}
</style>
